export default function Apply({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: Function;
}) {
  const social = [
    {
      img: require("./img/social/twitter.png"),
      url: "https://twitter.com/Monsterra_P2E",
    },
    {
      img: require("./img/social/telegram.png"),
      url: "https://t.me/monsterragame_chat",
    },
    {
      img: require("./img/social/discord.png"),
      url: "https://discord.gg/R5uG9WCyr7",
    },
    {
      img: require("./img/social/facebook.png"),
      url: "https://www.facebook.com/Monsterra-P2E-Game-100591379141319",
    },
    {
      img: require("./img/social/youtube.png"),
      url: "https://www.youtube.com/MonsterraNFTGame",
    },
    {
      img: require("./img/social/tiktok.png"),
      url: "https://www.tiktok.com/@monsterra_nftgame",
    },
  ];
  const items = [
    {
      icon: require("./img/ghost.png"),
      iconActive: require("./img/ghost_active.png"),
      title: "Apply Gaming Guild",
      url: "https://forms.gle/tf27NVEYZRBX26ks6",
    },
    {
      icon: require("./img/chart.png"),
      iconActive: require("./img/chart_active.png"),
      title: "Apply Listing Dapps",
      url: "https://forms.gle/ppMS1kiQAzU3WzbR9",
    },
    {
      icon: require("./img/megaphone.png"),
      iconActive: require("./img/megaphone_active.png"),
      title: "Apply Marketing Service",
      url: "https://forms.gle/KAavCgstFZqQPMGq7",
    },
    {
      icon: require("./img/airdrop.png"),
      iconActive: require("./img/airdrop_active.png"),
      title: "Apply Crypto Community",
      url: "https://forms.gle/t81MuRyyFq9mAhhB8",
    },
    {
      icon: require("./img/arrow.png"),
      iconActive: require("./img/arrow_active.png"),
      title: "Apply DeFi Protocol",
      url: "https://forms.gle/6spMRvaJFeQmYXxL7",
    },
    {
      icon: require("./img/party.png"),
      iconActive: require("./img/party_active.png"),
      title: "Apply Event Partner",
      url: "https://forms.gle/hDgPRkdn344QyVUeA",
    },
  ];
  return (
    isOpen && (
      <div
        className="fixed top-0 left-0 w-screen h-screen bg-center bg-cover z-50"
        style={{ backgroundImage: `url(${require("./img/artwork.png")})` }}
      >
        <div className="right-10 top-0 bottom-0 h-full  items-center absolute gap-4 hidden lg:flex">
          <div className="flex gap-10 flex-col">
            {social.map((item: any, index: number) => (
              <a href={item.url} className="cursor-pointer" target="_blank">
                <img
                  src={item.img}
                  className="h-8 w-8 transform hover:scale-125 duration-150"
                />
              </a>
            ))}
          </div>
        </div>
        <div className="h-screen overflow-auto">
          <div className="border-b border-[#504834] p-4 relative flex justify-between px-14 items-center">
            <img src={require("./img/avatar.png")} className="h-16 w-16" />
            <div className="text-center">
              <p className="text-[#D1C6AD] text-xl">
                @monsterrap2e.partnership
              </p>
              <p className="text-[#AEADB6] text-sm">
                A Revolutionary P2E Game Transforms Traditional Play-to-earn
                Games into Fun Zone
              </p>
            </div>
            <img
              onClick={() => {
                onClose();
              }}
              src={require("./img/close-icon.png")}
              className="h-10 w-10 opacity-60 hover:opacity-100 cursor-pointer duration-300"
            />
          </div>
          <div className="container mx-auto">
            <div className="w-full h-0 pb-[50%] relative">
              <div className="absolute top-0 left-0 w-full h-full p-[4px]">
                <div className="border-[#504834] border w-full h-full">
                  <iframe
                    className="w-full h-full"
                    // width="1280"
                    // height="720"
                    src="https://www.youtube.com/embed/__-ZdryY8Vk"
                    title="Monsterra Battle Front Testnet Is Live"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap flex-col md:flex-row">
              {items.map((item: any, index: number) => (
                <a
                  className="w-full md:w-1/2 py-[2px] px-[4px]"
                  href={item.url}
                  target="_blank"
                >
                  <div className="group  flex text-white bg-[#212025] hover:bg-[#4E453D] p-4 items-center gap-3 cursor-pointer">
                    <div className="w-8 h-8">
                      <img
                        src={item.icon}
                        className="group-hover:hidden w-full h-full object-contain"
                      />
                      <img
                        src={item.iconActive}
                        className="hidden group-hover:block w-full h-full object-contain"
                      />
                    </div>
                    <p className="text-[#D1C6AD] font-poppins">{item.title}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  );
}
